import React from 'react';
import PropTypes from 'prop-types';
import { formatIdentityTags } from '../../utils/identityHelpers';
import '../../styles/IdentityTags.css';

/**
 * Component for displaying identity tags (gender, orientation, etc.)
 */
const IdentityTags = ({ 
  tags, 
  type = 'default', 
  size = 'medium',
  onClick,
  selectable = false,
  selected = []
}) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  // Format tags to ensure they're in array format
  const formattedTags = formatIdentityTags(tags);

  // Handle tag click
  const handleTagClick = (tag) => {
    if (onClick && selectable) {
      onClick(tag);
    }
  };

  // Determine CSS classes based on props
  const getTagClasses = (tag) => {
    let classes = ['identity-tag', `identity-tag--${type}`, `identity-tag--${size}`];
    
    if (selectable) {
      classes.push('identity-tag--selectable');
      
      if (selected.includes(tag)) {
        classes.push('identity-tag--selected');
      }
    }
    
    return classes.join(' ');
  };

  return (
    <div className="identity-tags-container">
      {formattedTags.map((tag, index) => (
        <span
          key={`${tag}-${index}`}
          className={getTagClasses(tag)}
          onClick={() => handleTagClick(tag)}
          role={selectable ? 'button' : undefined}
          tabIndex={selectable ? 0 : undefined}
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

IdentityTags.propTypes = {
  tags: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  type: PropTypes.oneOf(['default', 'gender', 'orientation', 'travel', 'safety']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  onClick: PropTypes.func,
  selectable: PropTypes.bool,
  selected: PropTypes.arrayOf(PropTypes.string)
};

export default IdentityTags;
